import {
  CallHistoryService,
  CallListItem,
} from "@sorenson-eng/videophone-core-services";

export class SorensonCallHistoryService implements CallHistoryService {
  callHistoryItems?: CallListItem[];
}
